<template>
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div style="height: 20px"></div>
          <div class="card">
            <div class="card-header card-header-primary">
              <h3 class="card-title">
                Informations sur le livreur
              </h3>
            </div>
            <div class="card-body">
              <div>
                <b-alert
                  v-if="user.statusLivreur == '0'"
                  variant="danger"
                  show
                >
                  <p style="font-size: 1.3em">
                    Ce compte livreur est désactivé!!!
                  </p>
                </b-alert>
                <b-alert v-if="user.statusLivreur == '1'" variant="default"
                  show
                  style="background-color: #34b76e"
                >
                  <p style="font-size: 1.3em">
                    Ce compte livreur est activé!!!
                  </p>
                </b-alert>
              </div>

              <form @submit.prevent="onUpdateForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Nom du livreur
                      </label>
                      <input v-model="user.name" type="text" class="form-control" required style="border-radius: 10px 10px 10px 10px" disabled/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Contact du livreur
                      </label>
                      <input
                        v-model="user.number" type="text" class="form-control" required style="border-radius: 10px 10px 10px 10px" disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Status du livreur
                      </label>
                      <select class="form-control" v-model="user.statusLivreur" required style="border-radius: 10px 10px 10px 10px" disabled>
                        <option value="0">Desactivé ce livreur</option>
                        <option value="1">Activé ce livreur</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        class="bmd-label-floating"
                        style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Moyenne du livreur sur 5
                      </label>
                      <input v-model="note.notes" type="text" class="form-control" disabled/>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
                  <div class="row">
          
            <div class="col-md-4">
              <div class="card card-profile" style="background-color: #34b76e">
                <div class="card-avatar">
                  <h3 style="margin-left:5%" class="text-white">Recettes d'aujourd'hui</h3>
                </div>
                <div class="card-body">
                  <form action="">
                    <div id="daytotal">
                      <div class="form-group">
                         <input type="text"  v-model="dayTotal"  class="form-control" disabled>
                      </div>
                    </div> 
                    <div class="row">
                      <div class="col-6"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card card-profile" style="background-color: #34b76e">
                <div class="card-avatar">
                  <h3 style="margin-left:5%" class="text-white">Recettes de la semaine</h3>
                </div>
                <div class="card-body">
                  <form action="">
                    <div class="">
                      <div class="form-group">
                        <input type="text" v-model="weekTotal" class="form-control" disabled>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card card-profile" style="background-color: #34b76e">
                <div class="card-avatar">
                  <h3 style="margin-left:5%" class="text-white">Recettes de ce mois</h3>
                </div>
                <div class="card-body">
                  <form action="">
                    <div class="">
                      <div class="form-group">
                        <input type="text" v-model="monthTotal " class="form-control" disabled>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6"></div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
        </div>
                <div>
                  <h1>

                  </h1>
                </div>

                <div>
                  <div>
                    <h3>Historique de transaction</h3>
                  </div>
                   <table class="table">
                    <thead>
                      <tr> 
                        <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">#</th>
                        <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Nom expéditeur</th>
                        <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Date de livraison</th>
                        <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Montant</th>
                        <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Type de colis</th>
                        <th scope="col" style="color:#34B76E; font-weight:bold; font-size:0.9em">Adresse de destination</th>
                      </tr>
                      
                    </thead>

                    <tbody>
                      <tr v-for="coli in Colis" :key="coli.id">
                        <td>#</td>
                        <td>{{coli.client_name}}</td>
                        <td>{{coli.created_at}}</td>
                        <td>{{coli.montant}} FCFA</td>
                        <td>{{coli.colis_type}}</td>
                        <td>{{coli.dest_address}}</td>
                  </tr>
                    </tbody>
                  </table>
                </div>
                
              </form>
            </div>
          </div>
        </div>
      </div>

      <div style="height: 109px"></div>
    </div>
  </div>
</template>

<script>
import { db } from "../../main";
import Swal from "sweetalert2";
import moment from "moment";

export default {

  data() {
    return {
      id_route : this.$route.params.id,
      user: {},
      note: {},
      Colis: {},
      calculColis:{},
      timestamp: "",
      datetoday: "",
      month: "",
    };
  },  

  created() {
    setInterval(this.getNow, 1000);
    //////////////////////////////////////////////////////////
    let dbRef = db.ref("users").child(this.$route.params.id);
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.user = childData;
      })
      .catch((error) => {
        console.log(dbRef);
      });
      ////////////////////////////////////////////////////////////////////////
      let dbNoteRef = db.ref("Note Livreur").child(this.$route.params.id);
      dbNoteRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.note = childData;
      })
      .catch((error) => {
        console.log(dbNoteRef);
      });
      ////////////////////////////////////////////////////////////////////////
      db.ref("Colis Requetes").orderByChild('livreur_id').equalTo(this.$route.params.id)
      .once("value")
      .then(dataSnapshot => {
        const itemsArray = [];
        dataSnapshot.forEach(childSnapshot => {
          const childData = childSnapshot.val();
            this.Colis = childData;
           
          let dbRef = db.ref("users").child(this.Colis.livreur_id).get()
          .then((childSnapshot) => {
            const livreurData = childSnapshot.val();
            this.Livreur = livreurData;
          })
          itemsArray.push({
            id: childData.id_colis,
            client_name: childData.client_name,
            client_phone: childData.client_phone,
            colis_type: childData.colis_type,
            depart_address: childData.depart_address,
            dest_address: childData.dest_address,
            dest_contact: childData.dest_contact,
            montant: childData.montant,
            created_at: childData.created_at,
            nature: childData.nature,
            payment_method: childData.payment_method,
          });
        });
        this.Colis = itemsArray.reverse();
      });
  },

  computed:{
    dayTotal() {
      let summation = this.Colis;
      let Total = 0;
      let mont =0;

       const today = new Date();
       const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

       if(summation){
        
          for(let i =0; i<summation.length; i++)
          {
            const ttmonthString = summation[i].created_at;
            const changedDate = moment(ttmonthString).format('YYYY-MM-DD hh:mm');
            const today = new Date(changedDate);
            const Bdate = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            if (date == Bdate) {
                  mont = mont + summation[i].montant;
                }else{
                  mont = mont + 0;
                  }
          }
        
        }
         return Total = mont;
    
    },

    

    monthTotal(){
      let summation = this.Colis;
      let Total = 0;
      let mont =0;
      const today = new Date();
      const month = today.getFullYear()+'-'+(today.getMonth()+1);

       if(summation){
      
          for(let i =0; i<summation.length; i++)
          {
            const ttmonthString = summation[i].created_at;
            const changedDate = moment(ttmonthString).format('YYYY-MM-DD hh:mm');
            const tomonth = new Date(changedDate);
            const finmonth = tomonth.getFullYear()+'-'+(tomonth.getMonth()+1);
            if (month == finmonth) {
                  mont = mont + summation[i].montant;
                }else{
                  mont = mont + 0;
                  }
          }
        
        }
         return Total = mont;
      
     
    },


    weekTotal(){
      let summation = this.Colis;
      let Total = 0;
      let mont =0;
      const today = new Date();
      const month = today.getFullYear()+'-'+(today.getMonth()+1);
      const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

      //numero de la semaine actuel
      let d = new Date();
      let DoW = d.getDay();
      d.setDate(d.getDate() - (DoW + 6) % 7 + 3); // Nearest Thu
      let ms = d.valueOf(); // GMT
      d.setMonth(0);
      d.setDate(4); // Thu in Week 1
      let curWeek = Math.round((ms - d.valueOf()) / (7 * 864e5)) + 1;

       if(summation){
        
          for(let i =0; i<summation.length; i++)
          {
            const ttmonthString = summation[i].created_at;
            const changedDate = moment(ttmonthString).format('YYYY-MM-DD');
            //numero de la semaine à partir d'une date
            let dd = new Date(changedDate);
            let DDoW = dd.getDay();
            dd.setDate(dd.getDate() - (DDoW + 6) % 7 + 3); // Nearest Thu
            let ms = d.valueOf(); // GMT
            dd.setMonth(0);
            dd.setDate(4); // Thu in Week 1
            let datWeek = Math.round((ms - dd.valueOf()) / (7 * 864e5)) + 1;
            if (datWeek == curWeek) {
                  mont = mont + summation[i].montant;
                }else{
                  mont = mont + 0;
                  }
          }
        
        }
         return Total = mont;
      
     
    },
  },

  methods: {
    calcul(){
       db.ref("Colis Requetes").orderByChild('livreur_id').equalTo(this.$route.params.id)
      .on('value', (dataSnapshot) => {
        const itemsArray = [];
        dataSnapshot.forEach(childSnapshot => {
          itemsArray.push({
            montant: childData.montant,
            created_at: childData.created_at,
          })
             this.calculColis = itemsArray     
        });
      });
    },
    onUpdateForm(event) {
      let go = this;
      event.preventDefault();
      db.ref("users")
        .child(this.$route.params.id)
        .set(this.user)
        .then(() => {
          console.log("Mise à jour effectuée!");
          go.$router.push({ path: "/admin/livreur" });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Mise à jour éffectuée",
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    
      
  },
};
</script>

